import { Tab as ReactTab, Tabs, TabList, TabPanel } from "react-tabs";
import "./index.scss";
import 'react-tabs/style/react-tabs.css';

interface IProps {
    tabTitles: string[] | React.ReactNode[];
    tabContents: string[] | React.ReactNode[];
    defaultActiveTab?: number;
}

export const Tab = ({
    tabTitles,
    tabContents,
    defaultActiveTab = 0,
}: IProps) => {
    return (
        <Tabs defaultIndex={defaultActiveTab}>
            <TabList>
                {tabTitles.map((title, index) => (
                    <ReactTab key={index}>
                        {title}
                    </ReactTab>
                ))}
            </TabList>
            {tabContents.map((content, index) => (
                <TabPanel key={index}>
                    {content}
                </TabPanel>
            ))}
        </Tabs>
    )
}